var dotsThemeWeb = {
  activeColor: 'primary',
  inactiveColor: 'text.disabled',
  size: {
    active: 12,
    inactive: 8
  }
};

// NOTE -- dots got a bump  from emperorGrey to octoberGrey in the dark theme

var dotsThemeNative = {
  activeColor: 'primary',
  inactiveColor: 'text.disabled',
  size: {
    active: 12,
    inactive: 8
  }
};

export { dotsThemeNative, dotsThemeWeb };
